import request from '@/utils/request'

/**
 * Tag: Token
 */

const baseUrl ="api_Token";



/**
 * 获取token
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
async function _getToken(param) {
  return request(baseUrl+'_GetToken',{
    method: 'GET',
    params: param,
  });

}



export default{
  _getToken
}




// WEBPACK FOOTER //
// ./src/api/token.js